const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'syncline_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    clearToken();
    const err = new Error('Unauthorized');
    err.status = 401;
    throw err;
  }
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      detail = data.detail || detail;
    } catch (_) {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const adminApi = {
  login: (username, password) =>
    request('/auth/login', { method: 'POST', body: { username, password }, auth: false }),
  me: () => request('/auth/me'),
  // Orders
  listOrders: () => request('/admin/orders'),
  getOrder: (id) => request(`/admin/orders/${id}`),
  createOrder: (data) => request('/admin/orders', { method: 'POST', body: data }),
  updateOrder: (id, data) => request(`/admin/orders/${id}`, { method: 'PUT', body: data }),
  deleteOrder: (id) => request(`/admin/orders/${id}`, { method: 'DELETE' }),
  // Quotes
  listQuotes: () => request('/admin/quotes'),
  updateQuoteStatus: (id, status) =>
    request(`/admin/quotes/${id}`, { method: 'PUT', body: { status } }),
  deleteQuote: (id) => request(`/admin/quotes/${id}`, { method: 'DELETE' }),
  convertQuote: (id) => request(`/admin/quotes/${id}/convert`, { method: 'POST' }),
};

export const ORDER_STATUSES = [
  'Order Placed',
  'Picked Up',
  'In Transit',
  'Out for Delivery',
  'Delivered',
  'Cancelled',
];
